import React from 'react'
import img from '../../../../public/static/image-background/logo-v-02.png'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

const Mau10 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const color = {
        bg: '#0a3d2e',
        accent: '#f4c430',
        accentDark: '#c9980a',
        text: '#ffffff',
        headerBg: 'rgba(0,0,0,0.35)',
        row1: 'rgba(255,255,255,0.06)',
        row2: 'rgba(0,0,0,0.2)',
        border: 'rgba(244,196,48,0.35)',
        muted: 'rgba(255,255,255,0.5)'
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    return (
        <div
            id={id}
            style={{
                width: width,
                minHeight: width / 1.3,
                fontFamily: 'SFUHelveticaCondensedBold',
                background: `linear-gradient(150deg, #0a3d2e 0%, #0d5c42 45%, #083525 100%)`,
                position: 'relative',
                overflow: 'hidden',
                padding: `${px * 2.5}px`
            }}
        >
            {/* Decorative watermark background text */}
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: `${px * 38}px`,
                    fontWeight: 900,
                    color: 'rgba(255,255,255,0.025)',
                    userSelect: 'none',
                    zIndex: 0,
                    whiteSpace: 'nowrap',
                    letterSpacing: `${px * 1}px`
                }}
            >
                VSPORTS
            </div>

            {/* Gold corner accent top-right */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: 0,
                    height: 0,
                    borderStyle: 'solid',
                    borderWidth: `0 ${px * 22}px ${px * 22}px 0`,
                    borderColor: `transparent rgba(244,196,48,0.15) transparent transparent`,
                    zIndex: 0
                }}
            />
            {/* Gold corner accent bottom-left */}
            <div
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: 0,
                    height: 0,
                    borderStyle: 'solid',
                    borderWidth: `${px * 16}px 0 0 ${px * 16}px`,
                    borderColor: `transparent transparent transparent rgba(244,196,48,0.1)`,
                    zIndex: 0
                }}
            />

            {/* Main content */}
            <div style={{ position: 'relative', zIndex: 1 }}>

                {/* ===== HEADER ===== */}
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        background: color.headerBg,
                        borderRadius: `${px * 1.5}px`,
                        padding: `${px * 1.5}px ${px * 2}px`,
                        marginBottom: `${px * 2.5}px`,
                        borderBottom: `3px solid ${color.accent}`,
                        backdropFilter: 'blur(6px)'
                    }}
                >
                    {/* Season logo */}
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                        <Image src={dataSeason?.logo} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain' }} />
                    </div>

                    {/* Title block */}
                    <div style={{ flex: 6, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <h1
                            style={{
                                color: color.accent,
                                fontSize: `${px * 4.8}px`,
                                textTransform: 'uppercase',
                                margin: 0,
                                letterSpacing: `${px * 0.3}px`,
                                textShadow: `0 2px 10px rgba(244,196,48,0.6), 0 0 30px rgba(244,196,48,0.2)`
                            }}
                        >
                            {t(titleTemplate(dataSchedules[0]?.dataGo))}
                        </h1>
                        <h2
                            style={{
                                color: color.text,
                                fontSize: `${px * 2.4}px`,
                                textTransform: 'uppercase',
                                margin: `${px * 0.5}px 0 0`,
                                opacity: 0.88,
                                letterSpacing: `${px * 0.1}px`
                            }}
                        >
                            {dataSeason?.name}
                        </h2>

                        {/* numberRound — case 1: plain number */}
                        {t(numberRound) === numberRound && (
                            <div
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    background: color.accent,
                                    color: '#1a1a00',
                                    padding: `${px * 0.4}px ${px * 3}px`,
                                    borderRadius: `${px * 0.6}px`,
                                    fontSize: `${px * 2.2}px`,
                                    fontWeight: 'bold',
                                    marginTop: `${px * 0.8}px`,
                                    letterSpacing: `${px * 0.15}px`
                                }}
                            >
                                {t('round')} {numberRound}
                            </div>
                        )}

                        {/* numberRound — case 2: named round (semifinals, finals…) */}
                        {t(numberRound) && t(numberRound) !== numberRound && (
                            <div
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    background: color.accent,
                                    color: '#1a1a00',
                                    padding: `${px * 0.4}px ${px * 3}px`,
                                    borderRadius: `${px * 0.6}px`,
                                    fontSize: `${px * 2.2}px`,
                                    fontWeight: 'bold',
                                    marginTop: `${px * 0.8}px`,
                                    letterSpacing: `${px * 0.15}px`
                                }}
                            >
                                {t(numberRound)}
                            </div>
                        )}
                    </div>

                    {/* VSports logo */}
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                        <Image src={img} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain' }} />
                    </div>
                </div>

                {/* ===== MATCH ROWS ===== */}
                <div style={{ display: 'flex', flexDirection: 'column', gap: `${px * 1.2}px` }}>
                    {dataSchedules[0]?.dataGo
                        ?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')
                        ?.map((i, idx) => (
                            <Item
                                key={`${idx}${new Date()}`}
                                data={i}
                                px={px}
                                classCustom={classCustom}
                                idx={idx}
                                color={color}
                            />
                        ))}
                </div>

                {/* ===== SPONSORS ===== */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div
                        style={{
                            marginTop: `${px * 3}px`,
                            borderTop: `2px solid ${color.border}`,
                            paddingTop: `${px * 2}px`,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            gap: `${px * 2}px`,
                            background: 'rgba(255,255,255,0.07)',
                            borderRadius: `${px}px`,
                            padding: `${px * 1.5}px ${px * 2}px`
                        }}
                    >
                        {sponsorData?.slice(0, 10)?.map((i, idx) => (
                            <Image
                                key={idx}
                                src={i.logo || config.logo}
                                style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain' }}
                            />
                        ))}
                    </div>
                )}

                {/* ===== FOOTER ===== */}
                <p
                    style={{
                        textAlign: 'right',
                        color: 'rgba(244,196,48,0.6)',
                        fontSize: `${px * 1.8}px`,
                        marginTop: `${px * 1.5}px`,
                        letterSpacing: '2px',
                        margin: `${px * 1.5}px 0 0`
                    }}
                >
                    {window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}
                </p>
            </div>
        </div>
    )
}

// ===================== ITEM =====================
const Item = React.memo(
    ({ data, px, classCustom, idx, color }) => {
        const { t } = useTranslation()

        const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
        let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
        let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''

        const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']

        let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
        let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name

        let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
        let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

        const isEven = idx % 2 === 0

        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    background: isEven ? 'rgba(255,255,255,0.07)' : 'rgba(0,0,0,0.18)',
                    borderRadius: `${px * 0.8}px`,
                    border: `1px solid rgba(244,196,48,0.18)`,
                    padding: `${px * 1.2}px ${px * 1.8}px`,
                    gap: `${px * 1.2}px`,
                    minHeight: `${px * 10}px`
                }}
            >
                {/* ── Time/Date block ── */}
                <div
                    style={{
                        minWidth: `${px * 9}px`,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        flexShrink: 0
                    }}
                >
                    <span
                        style={{
                            color: color.accent,
                            fontSize: `${px * 3}px`,
                            fontWeight: 'bold',
                            lineHeight: 1,
                            textShadow: `0 0 8px rgba(244,196,48,0.4)`
                        }}
                    >
                        {formatDateTime(data?.dateTime, 'time')}
                    </span>
                    <span style={{ color: color.muted, fontSize: `${px * 1.3}px`, marginTop: `${px * 0.3}px`, textAlign: 'center', lineHeight: 1.2 }}>
                        {formatDateTime(data?.dateTime, 'date')}
                    </span>
                </div>

                {/* ── Divider ── */}
                <div style={{ width: `1px`, alignSelf: 'stretch', background: `rgba(244,196,48,0.25)`, flexShrink: 0 }} />

                {/* ── Home team ── */}
                <div
                    style={{
                        flex: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        gap: `${px * 1}px`,
                        overflow: 'hidden'
                    }}
                >
                    <Name
                        propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`}
                        name={homeName}
                        px={px}
                        align="right"
                    />
                    <Image
                        src={data?.homeTeam?.logo}
                        style={{
                            width: `${px * 6}px`,
                            height: `${px * 6}px`,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            border: `${px * 0.25}px solid ${color.accent}`,
                            boxShadow: `0 0 8px rgba(244,196,48,0.3)`,
                            flexShrink: 0,
                            backgroundColor: '#fff'
                        }}
                    />
                </div>

                {/* ── VS / Score center ── */}
                <div
                    style={{
                        minWidth: `${px * 22}px`,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }}
                >
                    {data?.isCompleted ? (
                        <>
                            <div
                                style={{
                                    background: 'rgba(0,0,0,0.5)',
                                    border: `2px solid ${color.accent}`,
                                    borderRadius: `${px * 0.6}px`,
                                    padding: `${px * 0.3}px ${px * 1.5}px`,
                                    color: color.accent,
                                    fontSize: `${px * 3.6}px`,
                                    fontWeight: 'bold',
                                    letterSpacing: '2px',
                                    textAlign: 'center',
                                    whiteSpace: 'nowrap',
                                    textShadow: `0 0 8px rgba(244,196,48,0.5)`
                                }}
                            >
                                {/* Bỏ cuộc cases */}
                                {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                                {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                                {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                                {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                            </div>
                            {data?.hasPenalty && (
                                <div style={{ color: '#fc0366', fontSize: `${px * 1.4}px`, marginTop: `${px * 0.4}px`, textAlign: 'center' }}>
                                    (PK: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore})
                                </div>
                            )}
                        </>
                    ) : (
                        <div
                            style={{
                                background: 'rgba(244,196,48,0.15)',
                                border: `2px solid rgba(244,196,48,0.5)`,
                                borderRadius: `${px * 0.6}px`,
                                padding: `${px * 0.5}px ${px * 1.8}px`,
                                color: color.accent,
                                fontSize: `${px * 2.8}px`,
                                fontWeight: 'bold',
                                letterSpacing: '3px',
                                textAlign: 'center'
                            }}
                        >
                            VS
                        </div>
                    )}
                </div>

                {/* ── Away team ── */}
                <div
                    style={{
                        flex: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        gap: `${px * 1}px`,
                        overflow: 'hidden'
                    }}
                >
                    <Image
                        src={data?.awayTeam?.logo}
                        style={{
                            width: `${px * 6}px`,
                            height: `${px * 6}px`,
                            borderRadius: '50%',
                            objectFit: 'cover',
                            border: `${px * 0.25}px solid rgba(255,255,255,0.5)`,
                            flexShrink: 0,
                            backgroundColor: '#fff'
                        }}
                    />
                    <Name
                        propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`}
                        name={awayName}
                        px={px}
                        align="left"
                    />
                </div>

                {/* ── Divider ── */}
                <div style={{ width: `1px`, alignSelf: 'stretch', background: `rgba(244,196,48,0.25)`, flexShrink: 0 }} />

                {/* ── Stadium ── */}
                <div
                    style={{
                        minWidth: `${px * 8}px`,
                        maxWidth: `${px * 12}px`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }}
                >
                    <span
                        style={{
                            color: color.muted,
                            fontSize: `${px * 1.4}px`,
                            textAlign: 'center',
                            lineHeight: 1.3,
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            maxWidth: `${px * 11}px`
                        }}
                    >
                        {data?.stadium || ''}
                    </span>
                </div>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data)
)

// ===================== NAME =====================
const Name = React.memo(
    ({ name, px, propClass, align }) => {
        const reSizeBasedOnWidth = () => {
            const el = document.querySelector(`.${propClass}`)
            const container = document.querySelector(`.contain${propClass}`)
            if (!el || !container) return
            let fontSize = window?.getComputedStyle(el)?.fontSize
            el.style.fontSize = parseFloat(fontSize) - 0.25 * px + 'px'
            if (el.scrollHeight > container.clientHeight) {
                reSizeBasedOnWidth()
            }
        }
        const processInput = () => {
            const el = document.querySelector(`.${propClass}`)
            if (!el) return
            el.innerHTML = name
            el.style.fontSize = px * 2.6 + 'px'
            reSizeBasedOnWidth()
        }

        React.useEffect(() => {
            processInput()
        }, [name])

        return (
            <div
                className={`contain${propClass}`}
                style={{
                    flex: 1,
                    height: `${px * 7}px`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
                    overflow: 'hidden'
                }}
            >
                <h2
                    className={propClass}
                    style={{
                        color: '#ffffff',
                        textAlign: align,
                        textTransform: 'uppercase',
                        margin: 0,
                        fontWeight: 'bold',
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        lineHeight: 1.2,
                        fontSize: `${px * 2.6}px`
                    }}
                />
            </div>
        )
    },
    (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

// ===================== IMAGE =====================
const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return (
        JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
    )
}

export default React.memo(Mau10, areEqual)
